import { Choicebox } from '@ksyos/design-system';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { getServiceData } from '../../data/getServiceData';
import { ServiceCardContent } from './ServiceCardContent';

interface IServiceCardProps {
    isSelected: boolean;
    onClick: (name: any) => void;
    service: ServiceForSelectedServiceType;
}
export function ServiceCard(props: IServiceCardProps) {
    const { isSelected, service, onClick } = props;

    const itemData = getServiceData(service);

    return (
        <Choicebox
            checked={isSelected}
            color="secondary"
            key={service.key}
            label={<ServiceCardContent data={itemData} />}
            onChange={async () => {
                onClick({
                    ...service,
                });
            }}
            style={{ order: itemData.order }}
        />
    );
}
